import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';
import blindsBlackout from '../../src/image/blinds-blackout.jpg';
import './theme.css';
import Breadcrumbs from './Breadcrumbs';

function Blinds() {

    useEffect(() => { AOS.init({ duration: 1000, once: true }); }, []);

    const keyFeatures = [
        { icon: 'bi-check-circle-fill', desc: 'High-quality blind materials' },
        { icon: 'bi-check-circle-fill', desc: 'Professional measurement & installation' },
        { icon: 'bi-check-circle-fill', desc: 'Smooth and durable mechanisms' },
        { icon: 'bi-check-circle-fill', desc: 'Blackout, translucent & light filtering options' },
        { icon: 'bi-check-circle-fill', desc: 'Remote-operated & smart motorized blinds available' },
    ]

    const features = [
        { title: 'Custom Fit & Finish', desc: 'Made-to-measure blinds with precise installation and smooth operation.' },
        { title: 'Light & Privacy Control', desc: 'From soft diffusion to full blackout  select the level of light control you need.' },
        { title: 'Smart Motorized Options', desc: 'Remote-controlled and automation-ready blinds for convenience and luxury.' }
    ];

    const typesOfBlinds = [
        { icon: 'bi-check-circle-fill', title: 'Roller Blinds', desc: 'Smooth, minimalistic, and modern ideal for living rooms, bedrooms, offices, and showrooms.' },
        { icon: 'bi-check-circle-fill', title: 'Zebra / Day & Night Blinds', desc: 'Dual-layered blinds that allow you to switch between natural light and complete privacy.' },
        { icon: 'bi-check-circle-fill', title: 'Vertical Blinds', desc: 'Perfect for large windows, balconies, hospitals, corporate spaces, and commercial interiors.' },
        { icon: 'bi-check-circle-fill', title: 'Venetian Blinds (Aluminium / PVC / Wooden)', desc: 'Classic and elegant slat-style blinds that allow precise control of light and airflow.' },
        { icon: 'bi-check-circle-fill', title: 'Honeycomb / Cellular Blinds', desc: 'Energy-efficient blinds designed to reduce heat and enhance insulation.' },
        { icon: 'bi-check-circle-fill', title: 'Motorized Blinds', desc: 'Smart, remote-controlled blinds for homes, offices, and high-end commercial spaces.' },
    ];


    return (
        <div className="container-fluid p-0 ">
            <Header />

            <section className="theme-section">
                <Breadcrumbs/>
              
                <div className="container" data-aos="fade-up">
                    <div className="theme-section-title text-center">
                        <h2>Premium Window Blinds for Homes & Commercial Interiors</h2>
                        <p>Upgrade your interiors with our wide range of high-quality window blinds, designed for modern homes, offices, retail spaces, and commercial buildings. We supply and install all types of blinds made from durable, elegant, and easy-to-maintain materials  available in both manual and motorized options.</p>
                        <p>Our blinds offer perfect control over light, privacy, and ventilation, while enhancing the overall style and functionality of your space.</p>
                    </div>

                    <div className="features">
                        {features.map((feature, idx) => (
                            <div key={idx} className="feature" data-aos="fade-up">
                                <h4>{feature.title}</h4>
                                <p className="small muted">{feature.desc}</p>

                            </div>
                        ))}
                    </div>

                    {/* Tab Content */}
                    <div className="theme-row" data-aos="fade-up">
                        <div className="col-lg-6 theme-col">
                            <h6>Key Features</h6>
                            <ul className="theme-features">
                                {keyFeatures.map((item, idx) => (
                                    <li key={idx}>
                                        <i className={`bi ${item.icon}`}></i> {item.desc}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-6 theme-col theme-image-wrapper" data-aos="zoom-in">
                            <img src={blindsBlackout} alt="Blinds" className="theme-image" />
                        </div>
                    </div>


                    <div className='theme-row' data-aos="fade-up">
                        <div className="theme-col">
                            <h6>Types of Window Blinds We Offer</h6>
                            <ul className="theme-features">
                                {
                                    typesOfBlinds.map((item, idx) => (
                                        <li key={idx}>
                                            <i className={`bi ${item.icon}`}></i>
                                            <span>{item.title}:</span> {item.desc}
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>


                    <div className='theme-row' data-aos="fade-up">
                        <div className="theme-col">
                            <h6>Materials & Finishes</h6>
                            <p className='muted small'>Choose from premium materials designed for durability, ECO friendly and style.</p>
                            <div className="fabric-list">
                                <div className="chip">Fabric</div>
                                <div className="chip">Blackout Coatings</div>
                                <div className="chip">Aluminium Slats</div>
                                <div className="chip">PVC</div>
                                <div className="chip">Wood & Faux Wood</div>
                                <div className="chip">Honeycomb Cells</div>
                            </div>
                        </div>
                    </div>



                    <div className='theme-row' data-aos="fade-up">
                        <div className="theme-col">
                            <h6>Where Our Blinds Are Ideal</h6>
                            <p className='muted small'>Perfect solutions for both residential and commercial projects.</p>
                            <div className='ideal-places'>
                                <div className="chip">Residential Homes & Apartments</div>
                                <div className="chip">Corporate Offices</div>
                                <div className="chip">Retail Stores & Showrooms</div>
                                <div className="chip">Schools & Institutions</div>
                                <div className="chip">Hospitals & Clinics</div>
                                <div className="chip">Hotels & Resorts</div>
                                <div className="chip">Industrial & Commercial Buildings</div>
                            </div>
                        </div>
                    </div>

                    {/* Feature Boxes */}
                    <div className="row theme-feature-section" data-aos="fade-up">
                        <div className="theme-feature-box">
                            <p className="theme-feature-description">Perfectly designed blinds that combine style, privacy, and comfort customized for every home and commercial interior.</p>
                        </div>
                    </div>

                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Blinds;
